import { Form } from 'antd';
import { useUpdateExpoBoothNo } from 'features/transaction_list/use-cases/update-expo-booth-number';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';


export const RefundViewModal = ({ onClose, isOpen, RefundData }: any) => {
    
    const formName = 'edit-booth-name-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<any>();
    const { isLoading, mutate } = useUpdateExpoBoothNo();
    const [editBoothId, setEditBoothId] = useState<number | null>(null)

    const location = useLocation();

    const pageFlag = location.pathname == "/transactions/expo-booth-list" ? 'BOOTH' : 'TICKETS';

    useEffect(() => {
        form.resetFields();
    }, [isOpen])

    const handleClose = () => {
        setEditBoothId(null);
        form.resetFields();
        onClose();
    };

    const handleUpdate = (formData: any) => {
        const payload = {
            Flag: "CHANGE",
            booth_no_old: editBoothId,      // Old booth id
            booth_no_new: +formData.booth_name,  // New booth name from form input
            pageFlag: pageFlag
        };
        mutate(payload, { onSuccess: handleClose });
    };


    return (

        <>
            <div className='popup'>
                <div className='modal_head'>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                    <h4>Refund Details</h4>
                </div>
                <div className='modal_body'>
                    <Form
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        // initialValues={getInitialValues}
                        onFinish={handleUpdate}
                        // requiredMark={'optional'}
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                        <FormSectionsSeparator title={""}>
                            <div className="main_data">
                                <div className="data_bx">
                                    <label>Event Name</label>
                                    <span>{RefundData?.EventName}</span>

                                </div>

                               
                                <div className="data_bx">
                                    <label>Phone Number</label>
                                    <span>{RefundData?.PhoneNumber}</span>
                                </div>
                                <div className="data_bx">
                                    <label>Refund Amount</label>
                                    <span>{RefundData?.RefundAmount}</span>
                                </div>
                                    <div className="data_bx">
                                    <label>Transaction Date</label>
                                    <span>{RefundData?.TransactionDate}</span>
                                </div>
                                  <div className="data_bx">
                                    <label>Auth Id</label>
                                    <span>{RefundData?.AuthId}</span>
                                </div>
                                  <div className="data_bx">
                                    <label>Order Id</label>
                                    <span>{RefundData?.BookingId}</span>
                                </div>
                                 <div className="data_bx">
                                    <label>Payment Method</label>
                                    <span>{RefundData?.PaymentType}</span>
                                </div>
                                <div className="data_bx">
                                    <label>User Name</label>
                                    <span>{RefundData?.UserName}</span>
                                </div>
                                <div className="data_bx">
                                    <label>Action By</label>
                                    <span>{RefundData?.RefundStatus}</span>
                                </div>
                                   <div className="data_bx">
                                    <label>Action On</label>
                                    <span>{RefundData?.ActionOn}</span>
                                </div>
                            </div>
                        </FormSectionsSeparator>
                    </Form>
                </div>
            </div>
        </>
    );
};
